<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">设置提现手续费管理</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input placeholder="请输入内容" v-model="input3" clearable class="input-with-select">
          <el-select @change="getselect" style="width:150px" v-model="select" slot="prepend" placeholder="请选择币种">
            <el-option label="所有币种" value=""></el-option>
            <el-option v-for="coin in coinTypes" :label="coin" :value="coin" :key="coin"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="showTempData(1)" type="primary">批量设置</el-button>
      </div>
     <el-table
    :data="withdrawList"
    border>
    <el-table-column class="data-table" 
        label="币种" width="100"
        prop="coinType"
      ></el-table-column>
      <el-table-column label="手续费模式" width="100" prop="withdrawFeeType"></el-table-column>
      <el-table-column
        label="手续费" width="100"
        prop="withdrawFee"
      ></el-table-column>
      <el-table-column
        label="精度" width="100">
        <template slot-scope="scope">
          {{scope.row.withdrawFeeType == "模式一"?'--':scope.row.costPrecision}}
        </template>
      </el-table-column>
      <el-table-column
        label="提现成本（USDT）" width="150"
      >
        <template slot-scope="scope">
          {{scope.row.withdrawFeeType == "模式一"?'--':scope.row.cost}}
        </template>
      </el-table-column>
      <el-table-column
        label="币种价格（USDT）" width="150"
      >
        <template slot-scope="scope">
          {{scope.row.lastCoinPrice}}
        </template>
      </el-table-column>
      <el-table-column
        label="标签分组" width="100"
        prop="groupName"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="300px">
        <template slot-scope="scope">
          <el-button type="text" @click="onswitch(scope.row)">模式切换</el-button>
          <el-button type="text" @click="setting(scope.row)">设置</el-button>
          <el-button type="text" @click="onlab(scope.row)">标签</el-button>
          <el-button type="text" @click="onhistory(scope.row.id)">历史记录</el-button>
          <el-button type="text" @click="onoffice(scope.row.id)">操作记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 30px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginations.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="paginations.size"
      layout="total, sizes, prev, pager, next, jumper"
        :total="tagTotal">
    </el-pagination>   
    <div class="labe">说明：模式一是手动设置提现手续费，模式二是设置提现成本，通过定时（1个小时）获取币种价格计算提现手续费（提现手续费=提现成本/获取价格）</div>
      </el-card>
    <div class="temp-data-dialog">
      <batch-setting ref="tempDataRef"></batch-setting>
    </div>
    <div class="temp-data-dialog">
      <mode-switchs ref="tempMode"></mode-switchs>
    </div>
    <div class="temp-data-dialog">
      <history-record ref="historyrecord"></history-record>
    </div>
    <div class="temp-data-dialog">
      <office-record ref="officerecord"></office-record>
    </div>
  </div>
</template>

<script>
import "./store";
import api from "./api";
import { mapActions, mapState } from "vuex";
import coinSelect from "../../components/coinSelect";
import BatchSetting from './components/BatchSetting.vue';
import ModeSwitchs from './components/ModeSwitchs.vue';
import HistoryRecord from './components/HistoryRecord.vue'
import OfficeRecord from './components/OfficeRecord.vue'
export default {
  name: "withdrawal",
  components: { coinSelect,BatchSetting ,ModeSwitchs,HistoryRecord,OfficeRecord},
  data() {
    return {
      coninary:[{coin:'BTC',value:'1'},{coin:'USDT',value:'2'},{coin:'ETH',value:'3'},{coin:'EKX',value:'4'}],
      input3: '',
      select: '',
      paginations: {
        page: 1,
        size: 10
      }
    };
  },
  computed: {
    ...mapState('withdrawal', ['pagination','withdrawList','coinGroup','tagTotal','coinTypes']),
  },
  mounted() {
    
  },
  methods: {
    handleSizeChange(val) {
        this.paginations.size = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.paginations.page = val;
        this.getList();
    },
    ...mapActions('withdrawal', ['getCoinWithdrawFeeConfigList','getCoinGroup','getCoinTypes']),
    getList(){
      this.getCoinWithdrawFeeConfigList({
        ...this.paginations,
        coinType:this.input3? this.input3 : ''
      });
    },
    search(){
      // this.getCoinWithdrawFeeConfigList({
      //   ...this.paginations,
      //   coinType:this.input3? this.input3 : ''
      // });
      this.paginations.page = 1;
      this.getList()
    },
    getselect(val){
      this.input3 = val
    },
    onswitch(data){
      this.$refs['tempMode'].showData(data,1,this.paginations)
    },
    setting(data){
      this.$refs['tempMode'].showData(data,2,this.paginations)
    },
    onlab(data){
      this.$refs['tempMode'].showData(data,3,this.paginations)
    },
    showTempData() {
      api.getCoinGroup().then(({data})=>{
        this.$refs["tempDataRef"].showData(data,this.paginations);
      })
        
    },
    onhistory(id){
      this.$refs['historyrecord'].showData(id)
    },
    onoffice(id){
      this.$refs['officerecord'].showData(id)
    }
  },
  filters: {
  },
  created() {
    this.getList()
    this.getCoinTypes()
     
  },
};
</script>

<style lang="less" scoped>
.data-table {
  margin-top: 30px;
  font-size: 12px;
}
.labe{
  margin-top: 20px;
  color: red;
}

.snd-btn {
  margin: 10px 0px 0px 0px;
}
.btn-wrap {
  margin-top: 30px;
}

</style>
